(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pps-footer-discount')) {
    customElements.define('pps-footer-discount', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.pps-footer__copy-code');
        const code = this.querySelector('.pps-footer__discount-code');
        const status = this.querySelector('.pps-footer__copy-status');
        if (!button || !code || !status) return;

        button.hidden = false;
        button.onclick = async () => {
          if (button.disabled) return;
          button.disabled = true;
          status.textContent = '';
          let copied = false;

          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(code.value);
              copied = true;
            }
          } catch (error) {}

          if (!copied) {
            code.focus();
            code.select();
            code.setSelectionRange(0, code.value.length);
            try {
              copied = document.execCommand('copy');
            } catch (error) {}
          }

          status.textContent = copied
            ? button.dataset.copiedLabel
            : button.dataset.copyError;
          button.disabled = false;
          if (copied) button.focus({ preventScroll: true });
        };
      }

      disconnectedCallback() {
        const button = this.querySelector('.pps-footer__copy-code');
        if (button) button.onclick = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-gang-sheet"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const galleries = root.matches?.('[data-pps-gallery]') ? [root] : root.querySelectorAll('[data-pps-gallery]');
      galleries.forEach((gallery) => {
        if (gallery.dataset.ppsInitialized) return;
        gallery.dataset.ppsInitialized = 'true';
        gallery.querySelectorAll('.pps-pdp__app .gs--button').forEach((control) => {
          if (control.tagName !== 'DIV') return;
          control.setAttribute('role', 'button');
          control.tabIndex = 0;
          control.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            control.click();
          });
        });
        const image = gallery.querySelector('.pps-pdp__main-image');
        const thumbnails = gallery.querySelector('.pps-pdp__thumbnails');
        if (!image || !thumbnails) return;
        thumbnails.hidden = false;
        thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('[data-image-url]');
          if (!button || !thumbnails.contains(button)) return;
          const url = new URL(button.dataset.imageUrl, window.location.href);
          image.srcset = [320,480,640,800,1000,1200,1400].map((width) => {
            url.searchParams.set('width', width);
            return `${url.href} ${width}w`;
          }).join(', ');
          image.src = button.dataset.imageUrl;
          image.alt = button.dataset.imageAlt;
          image.width = Number(button.dataset.imageWidth);
          image.height = Number(button.dataset.imageHeight);
          thumbnails.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const mount = root => {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, { ...options, signal: controller.signal });
    const video = root.querySelector('video');
    const place = root.querySelector('[data-pps-location]');
    const button = root.querySelector('[data-pps-hero-motion]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const initial = place.textContent.trim();
    const locations = [initial, 'San Jose', 'Santa Clara', 'Sunnyvale', 'Cupertino', 'Fremont', 'Palo Alto'].filter((value,index,array)=>value !== 'Mountain View' && array.indexOf(value)===index);
    const locationRow = root.querySelector('.pps-home-hero__location-row');
    const locationPrefix = root.querySelector('.pps-home-hero__location-prefix');
    const fitLocation = () => {
      locationRow.style.removeProperty('font-size');
      if (!matchMedia('(max-width: 749px)').matches || !locationRow.clientWidth) return;
      const style = getComputedStyle(locationRow);
      const needed = locationPrefix.getBoundingClientRect().width + place.scrollWidth + parseFloat(style.columnGap);
      if (needed > locationRow.clientWidth - 2) {
        const size = parseFloat(style.fontSize) * (locationRow.clientWidth - 2) / needed;
        locationRow.style.fontSize = size + 'px';
      }
    };
    on(window, 'resize', fitLocation);
    document.fonts.ready.then(() => { if (!controller.signal.aborted) fitLocation(); });
    fitLocation();
    let visible = false, paused = false, manual = false, index = 0, timer = 0, fade = 0;
    const preferencesAllow = () => !reduced.matches && !connection?.saveData && !/^(slow-2g|2g)$/.test(connection?.effectiveType || '');
    const allowed = () => visible && !document.hidden && !paused && (manual || preferencesAllow()) && !window.Shopify?.designMode;
    const rotate = root.dataset.rotateCities === 'true';
    const clear = () => { clearTimeout(timer); clearTimeout(fade); timer = 0; fade = 0; place.classList.remove('is-changing'); };
    const schedule = () => {
      if (!rotate || !allowed() || root.contains(document.activeElement)) return;
      timer = setTimeout(() => {
        timer = 0;
        if (!allowed()) return;
        place.classList.add('is-changing');
        fade = setTimeout(() => {
          fade = 0;
          if (!allowed()) { place.classList.remove('is-changing'); return; }
          index = (index + 1) % locations.length;
          place.textContent = locations[index];
          fitLocation();
          place.classList.remove('is-changing');
          schedule();
        }, 180);
      }, 6500);
    };
    const sync = () => {
      clear();
      const active = allowed();
      if (video) {
        if (active) video.play()?.catch(() => {});
        else video.pause();
      }
      button.textContent = active ? 'Pause motion' : 'Play motion';
      button.setAttribute('aria-label', active ? 'Pause background motion' : 'Play background motion');
      button.setAttribute('aria-pressed', String(!active));
      if (active) schedule();
    };
    if (video) { video.muted = true; video.loop = true; video.setAttribute('playsinline',''); }
    button.hidden = !video && !rotate;
    on(button, 'click', () => {
      if (allowed()) paused = true;
      else { paused = false; manual = true; }
      sync();
    });
    on(root, 'focusin', clear);
    on(root, 'focusout', () => { clearTimeout(timer); timer = setTimeout(() => { timer = 0; clear(); schedule(); }, 0); });
    on(document, 'visibilitychange', sync);
    on(reduced, 'change', () => {
      manual = false;
      if (reduced.matches) { index = 0; place.textContent = initial; fitLocation(); }
      sync();
    });
    if (connection?.addEventListener) on(connection, 'change', sync);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: .1 });
      observer.observe(root);
      instances.set(root, () => { clear(); controller.abort(); observer.disconnect(); video?.pause(); instances.delete(root); });
    } else {
      visible = true;
      instances.set(root, () => { clear(); controller.abort(); video?.pause(); instances.delete(root); });
    }
    sync();
  };
  const scan = target => {
    if (target.matches?.('[data-pps-clean-hero]')) mount(target);
    target.querySelectorAll('[data-pps-clean-hero]').forEach(mount);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-pps-clean-hero]').forEach(root=>instances.get(root)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-local-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
 const mounted = new WeakMap();
 const mount = bar => {
  if(mounted.has(bar)) return;
  const hoursEl=bar.querySelector('[data-pps-hours]'),minutesEl=bar.querySelector('[data-pps-minutes]'),secondsEl=bar.querySelector('[data-pps-seconds]');
  if(!hoursEl||!minutesEl||!secondsEl)return;
  const TIME_ZONE = 'America/Los_Angeles';


  const formatter = new Intl.DateTimeFormat(
    'en-US',
    {
      timeZone: TIME_ZONE,

      year: 'numeric',
      month: '2-digit',
      day: '2-digit',

      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',

      hourCycle: 'h23'
    }
  );


  function getPacificParts(date) {

    const parts = formatter.formatToParts(date);

    const result = {};

    for (const part of parts) {

      if (part.type !== 'literal') {
        result[part.type] = Number(part.value);
      }

    }

    return result;
  }


  function getOffsetMs(date) {

    const p = getPacificParts(date);

    const reconstructed = Date.UTC(
      p.year,
      p.month - 1,
      p.day,
      p.hour,
      p.minute,
      p.second
    );

    return reconstructed - date.getTime();
  }


  function pacificDateToUtc(
    year,
    month,
    day,
    hour,
    minute,
    second
  ) {

    const guess = Date.UTC(
      year,
      month - 1,
      day,
      hour,
      minute,
      second
    );

    let date = new Date(guess);

    let offset = getOffsetMs(date);

    date = new Date(
      guess - offset
    );

    const correctedOffset =
      getOffsetMs(date);

    if (correctedOffset !== offset) {

      date = new Date(
        guess - correctedOffset
      );

    }

    return date;
  }


  function addCalendarDays(
    year,
    month,
    day,
    amount
  ) {

    const date = new Date(
      Date.UTC(
        year,
        month - 1,
        day + amount
      )
    );

    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    };
  }


  function isWeekend(
    year,
    month,
    day
  ) {

    const weekday = new Date(
      Date.UTC(
        year,
        month - 1,
        day
      )
    ).getUTCDay();

    return (
      weekday === 0 ||
      weekday === 6
    );
  }


  function getNextCutoff() {

    const now = new Date();

    const p = getPacificParts(now);

    let targetDate = {
      year: p.year,
      month: p.month,
      day: p.day
    };


    let cutoff = pacificDateToUtc(
      targetDate.year,
      targetDate.month,
      targetDate.day,
      10,
      0,
      0
    );


    if (
      isWeekend(
        targetDate.year,
        targetDate.month,
        targetDate.day
      ) ||
      now >= cutoff
    ) {

      do {

        targetDate = addCalendarDays(
          targetDate.year,
          targetDate.month,
          targetDate.day,
          1
        );

      } while (
        isWeekend(
          targetDate.year,
          targetDate.month,
          targetDate.day
        )
      );


      cutoff = pacificDateToUtc(
        targetDate.year,
        targetDate.month,
        targetDate.day,
        10,
        0,
        0
      );

    }


    return cutoff;
  }


  let cutoff = getNextCutoff();


  function updateTimer() {

    const now = new Date();


    if (now >= cutoff) {

      cutoff = getNextCutoff();

    }


    const remaining = Math.max(
      0,
      cutoff.getTime() -
      now.getTime()
    );


    const totalSeconds =
      Math.floor(
        remaining / 1000
      );


    const hours =
      Math.floor(
        totalSeconds / 3600
      );


    const minutes =
      Math.floor(
        (totalSeconds % 3600) / 60
      );


    const seconds =
      totalSeconds % 60;


    hoursEl.textContent =
      String(hours).padStart(2, '0');


    minutesEl.textContent =
      String(minutes).padStart(2, '0');


    secondsEl.textContent =
      String(seconds).padStart(2, '0');

  }


  let interval;
  const sync=()=>{clearInterval(interval);if(!document.hidden){updateTimer();interval=setInterval(updateTimer,1000);}};
  document.addEventListener('visibilitychange',sync);sync();
  mounted.set(bar,()=>{clearInterval(interval);document.removeEventListener('visibilitychange',sync);mounted.delete(bar);});
 };
 const scan=target=>{if(target.matches?.('[data-pps-local-bar]'))mount(target);target.querySelectorAll('[data-pps-local-bar]').forEach(mount);};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
 document.addEventListener('shopify:section:load',event=>scan(event.target));
 document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('[data-pps-local-bar]').forEach(bar=>mounted.get(bar)?.());});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-pre-cut"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const galleries = root.matches?.('[data-pps-gallery]') ? [root] : root.querySelectorAll('[data-pps-gallery]');
      galleries.forEach((gallery) => {
        if (gallery.dataset.ppsInitialized) return;
        gallery.dataset.ppsInitialized = 'true';
        gallery.querySelectorAll('.pps-precut__app .gs--button').forEach((control) => {
          if (control.tagName !== 'DIV') return;
          control.setAttribute('role', 'button');
          control.tabIndex = 0;
          control.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            control.click();
          });
        });
        const image = gallery.querySelector('.pps-precut__main-image');
        const thumbnails = gallery.querySelector('.pps-precut__thumbnails');
        if (!image || !thumbnails) return;
        thumbnails.hidden = false;
        thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('[data-image-url]');
          if (!button || !thumbnails.contains(button)) return;
          const url = new URL(button.dataset.imageUrl, window.location.href);
          image.srcset = [320,480,640,800,1000,1200,1400].map((width) => {
            url.searchParams.set('width', width);
            return `${url.href} ${width}w`;
          }).join(', ');
          image.src = button.dataset.imageUrl;
          image.alt = button.dataset.imageAlt;
          image.width = Number(button.dataset.imageWidth);
          image.height = Number(button.dataset.imageHeight);
          thumbnails.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
